import 'css-chunksrc/client/pages/projectPage/synthesisPage/monitoringLoader/stats/styles.scss';export default {
  "stats": "_stats_6o2d7_1",
  "col": "_col_6o2d7_8",
  "row": "_row_6o2d7_13",
  "label": "_label_6o2d7_23",
  "value": "_value_6o2d7_28"
};